import priyamvadamaam from "./images/PriyamvadaMaam.jpg";
import steffi from "./images/Steffi.jpeg";
import sharvari from "./images/Sharvari.jpg";
import durvesh from "./images/Durvesh.jpg";
import aryan from "./images/Aryan1.jpg";
import ishita from "./images/Ishita.jpg";
import tirthesh from "./images/Tirthesh.JPG";
import purvi from "./images/Purvi.jpg";
import revant from "./images/Revant.jpg";
import tanmay from "./images/Tanmay.jpg";
import luziana from "./images/Luziana.jpg";
import aayush from "./images/Aayush.jpg";
import evan from "./images/Evan.jpg";
import reena from "./images/Reena.jpeg";
import wynona from "./images/wynona.jpg";


const TeamDetails = [
    {
        "id": 1,
        "img": priyamvadamaam,
        "name": "Ms. Priyamvada Singh",
        "post": "Faculty Coordinator",
        "ig": "",
        "linkedin": "",
        "git": "",
        "twit": ""
    },
    {
        "id": 2,
        "img": steffi,
        "name": "Steffi Mary Varghese",
        "post": "President",
        "ig": "https://www.instagram.com/steffmv_?igsh=YnBjMmRwcjJmdnZ1&utm_source=qr",
        "linkedin": "http://linkedin.com/in/steffi-varghese-9a40182a0",
        "git": "http://github.com/Steffimv",
        "twit": ""
    },
    {
        "id": 3,
        "img": sharvari,
        "name": "Sharvari Kulkarni",
        "post": "Vice President",
        "ig": "https://www.instagram.com/sharvarik2224?igsh=aWpwc2dnZWV6bTI4",
        "linkedin": "https://www.linkedin.com/in/sharvari-kulkarni-a155582a7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "git": "https://github.com/Sharvari2224",
        "twit": ""
    },
    {
        "id": 4,
        "img": durvesh,
        "name": "Durvesh Mahajan",
        "post": "Operational Secretary",
        "ig": "https://www.instagram.com/durvesh_24_04?igsh=MXg4OW1ibHU3dHBjbw%3D%3D&utm_source=qr",
        "linkedin": "https://www.linkedin.com/in/durvesh-mahajan-a53ba3284?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        "git": "https://github.com/durvesh-24",
        "twit": ""
    },
    {
        "id": 5,
        "img": aryan,
        "name": "Aryan Nair",
        "post": "Technical Head",
        "ig": "https://www.instagram.com/_aryan_nair_18/",
        "linkedin": "https://www.linkedin.com/in/aryan-nair-244181308/",
        "git": "https://github.com/ASN-cmd",
        "twit": ""
    }, {
        "id": 6,
        "img": tirthesh,
        "name": "Tirthesh Kolhe",
        "post": "Treasurer",
        "ig": "https://www.instagram.com/tirtheshkolhe/",
        "linkedin": "http://www.linkedin.com/in/tirthesh-kolhe-872473255",
        "git": "https://github.com/tirthesh164",
        "twit": ""
    },
    {
        "id": 7,
        "img": luziana,
        "name": "Luziana Dmello",
        "post": "Creative Head",
        "ig": "https://www.instagram.com/luziana_dmello/",
        "linkedin": "http://www.linkedin.com/in/luziana-d-mello-262bb6307",
        "git": "https://github.com/creativeluziana",
        "twit": ""
    },
    {
        "id": 8,
        "img": evan,
        "name": "Evan Mathew",
        "post": "Creative Coordinator",
        "ig": "https://www.instagram.com/evaan.mathew?igsh=OHBhb2RhZTY1dXI=",
        "linkedin": "",
        "git": "",
        "twit": ""
    },

    {
        "id": 9,
        "img": wynona,
        "name": "Wynona Toby",
        "post": "Creative Coordinator",
        "ig": "https://www.instagram.com/wynona.toby?igsh=MTF3aWs0Mmt2cmdieA==",
        "linkedin": "http://www.linkedin.com/in/wynona-toby-0b57262a0",
        "git": "https://github.com/wynona-toby",
        "twit": ""
    },

    {
        "id": 10,
        "img": ishita,
        "name": "Ishita Patil",
        "post": "PR Head",
        "ig": "https://www.instagram.com/ishitaaa_patil?igsh=enVzOWo5d29vNjhk",
        "linkedin": "",
        "git": "",
        "twit": ""
    },
    {
        "id": 11,
        "img": purvi,
        "name": "Purvi Passi",
        "post": "Sponsorship Head",
        "ig": "https://www.instagram.com/purvi_passi?igsh=MXByZzM2ZWdlMTFyZA==",
        "linkedin": "https://www.linkedin.com/in/purvi-passi-88064927b/",
        "git": "https://github.com/pxxpassi/",
        "twit": ""
    },
    {
        "id": 12,
        "img": aayush,
        "name": "Aayush Nehete",
        "post": "Documentation Head",
        "ig": "https://www.instagram.com/aayush___2004?igsh=Z2F6NnFmOTc3bGw3",
        "linkedin": "http://www.linkedin.com/in/aayush-nehete-990819312",
        "git": "https://github.com/Aayushn20",
        "twit": ""
    },

    {
        "id": 13,
        "img": reena,
        "name": "Reena Moncy",
        "post": "Asst. Documentation Head",
        "ig": "https://www.instagram.com/reena_moncy?igsh=eXN6eHcyZzBsejJw&utm_source=qr",
        "linkedin": "http://www.linkedin.com/in/reena-moncy-74b189308",
        "git": "https://github.com/reenamoncy",
        "twit": ""
    },

    {
        "id": 14,
        "img": tanmay,
        "name": "Tanmay Chavan",
        "post": "Technical Coordinator",
        "ig": "https://www.instagram.com/tanmay_chavan_36/?next=%2F",
        "linkedin": "https://www.linkedin.com/in/tanmay-chavan-2832432b7/",
        "git": "https://github.com/tanmaychavan14",
        "twit": ""
    },

    {
        "id": 15,
        "img": revant,
        "name": "Revant Shinde",
        "post": "Technical Coordinator",
        "ig": "https://www.instagram.com/revantshinde?igsh=OGN0NHNjNTZwbGZ5",
        "linkedin": "https://www.linkedin.com/in/revant-shinde",
        "git": "https://github.com/Revant-1",
        "twit": ""
    }
   
]

export default TeamDetails;